export const createEventsMixin = (options) => {
    return {
        computed: {
            $page() {
                var _a, _b;
                const $pagePluginOverride = (_a = options === null || options === void 0 ? void 0 : options.mixinHooks) === null || _a === void 0 ? void 0 : _a.$page(this);
                if ($pagePluginOverride) {
                    return $pagePluginOverride;
                }
                else {
                    if (!this.$route) {
                        throw new Error('EventsMixin.$page was unable to find a route. Ensure vue-router is setup correctly');
                    }
                    const routeMetaValue = (_b = this.$route.meta) === null || _b === void 0 ? void 0 : _b.uiEvents_page;
                    const routeName = this.$route.name;
                    const routePath = this.$route.path;
                    return routeMetaValue || routeName || routePath;
                }
            },
        },
    };
};
//# sourceMappingURL=EventsMixin.js.map